var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.tags),function(tag){return _c('v-chip',{key:tag,staticClass:"ma-1",attrs:{"small":"","dense":"","label":"","color":_vm.color}},[_vm._v(" "+_vm._s(tag)+" ")])}),1)}
var staticRenderFns = []

export { render, staticRenderFns }